const fuelsType = {
  namespaced: true,
  state: {
    fuels: "",
  },
  actions: {
    getFuelsList({ commit, rootState }) {
      rootState.axios
        .get("/api/getFuelsList")
        .then((fuels) => {
          const payload = fuels.data.payload;
          commit("FETCH_FUELS_LIST", payload);
        })
        .catch((error) => console.log("error ", error));
    },
    isBlendedProduct({ rootGetters }, payload) {
      const blendedProductConfig = rootGetters["metadata/blendedProductConfig"];
      return blendedProductConfig.includes(payload);
    },
  },
  mutations: {
    FETCH_FUELS_LIST: (state, payload) => {
      state.fuels = payload;
    },
  },
  getters: {
    getFuelsType: (state) => {
      return state.fuels || [];
    },
    getSpotFuels: (state) => {
      const fuels = state.fuels.filter((product) => product.type === "SPOT");
      return fuels;
    },
  },
};


export default fuelsType